/* Add CustomFields Sep 23, 2023 */
/* Add TeamMembers(Contact Owners) Oct 7, 2023 */
/* Add email, phoneno,website, others to Custom Fields Nov 18, 2023 */
/* Add sortable:true Nov 25, 2023 */
/* Add officePhoneno, mobilePhoneNo, otherPhoneNo Aug 24, 2024 */
/* Amend for Performance and add My Contacts Dec 7, 2024 */
/* Add multiSelect to CustomData Dec 21, 2024 */
/* Add Accounts column  for Read Only columns Jan 25, 2025 */
/* Add "By Last Contact Date"   Feb 28, 2025 */
/* Add reportWidth, notes  Apr 30, 2026 */
<template lang="pug">
	div(class="oppr-nav")
		div(class="nav-header")
			div
				b-button(v-for="t in d_tabs" :key="t.ix" variant="none" :pressed="d_tabCurr.ix==t.ix" @click="m_tabClick(t)") {{t.lbl}}
			
			slot(name="team-member-filter" :fCU="d_tabCurr.ix>1" :fTM="d_tabCurr.ix!=1")
		div
			b-card(v-for="tabTbl in d_tabCurr.tabTbls||[d_tabCurr]" :key="tabTbl.ix" style="border:none;margin:0;")
				b-card-header
					b-button-group
						span(v-for="(fb, ix) in tabTbl.filterBtns" :key="ix" 
							class="btn btn-outline-secondary"
							:class="fb.state?'btn-active':null"
							:title="tabTbl.fn_fbTitle(fb)"
							@click="tabTbl.fn_fbClick(fb)"
							) {{fb.label}}
			b-card-body(style="padding:0")
				kt-table(
						p_appEntKey="extr" 
						:ref="'kt-table'+c_tblIdKey"
						:p_tblIdKey="c_tblIdKey"
						:p_opts="c_ktOptions"
						:p_cols="c_ktColumns"
						:p_qryPrms="c_qryPrms" 
						:p_tbNote="c_tbNote"
						:p_tbInfo="c_tbInfo"
						:p_skipLoad="c_skipLoad||null"
						:p_data="d_data||[]"
						)
</template>

<script>
import KTTable from "@/components/Ctrl/KT-Table.vue";
import util,{fn_hrefVwRec} from "@/utils/util.js";
import {userInfo,userSettings,refData} from "@/utils/ref-data.js";
export default {
	name: "extr-nav",
	components: {
		"kt-table": KTTable
	},
	created() {
		this.d_tabs = fn_getTabs(this);
		console.log('this.d_tabs');
		console.log(this.d_tabs);
		
		var d_qryPrms;
		if(window.localStorage.getItem(window.location.href+'-quickFilter')) {
			
			try{
				d_qryPrms=JSON.parse(window.localStorage.getItem(window.location.href+'-quickFilter'));
				} catch(err){d_qryPrms=null;}
		
			if(d_qryPrms) {
				this.d_tabs[d_qryPrms.ix].qryPrms=d_qryPrms;
				this.d_tabCurr = this.d_tabs[d_qryPrms.ix];
				if(d_qryPrms.ix==2&&d_qryPrms.days) { 
					var lastContactDate=new Date();
					d_qryPrms.lastContactDate=util.fn_isoDtStr(lastContactDate.setDate(lastContactDate.getDate()+d_qryPrms.days));
					this.d_tabCurr.filterBtns.forEach(b=>{b.state=b.days==d_qryPrms.days;});
					}
			}  
		
		} else this.d_tabCurr = this.$parent.d_cuFilter ? this.d_tabs[1] : this.d_tabs[0];
		
	},
	data() {
		return {
			d_tabs: [],
			d_tabCurr: {},
			d_teamMemberId: userInfo.getUserInfo().teamMember.teamMemberId,	
			d_withArchived:false,
		
		};
	},
	computed: {
		c_ktOptions() {return {};},
		c_tblIdKey(){return this.d_tabCurr.tblIdKey;},
		c_qryPrms(){return this.d_tabCurr.qryPrms;},
		c_tbNote(){return this.d_tabCurr.tbNote;},
		c_tbInfo(){return this.d_tabCurr.fn_tbInfo();},
		c_skipLoad(){return this.d_tabCurr.skipLoad;},
		c_ktColumns() {
			var columns = [
				{
					field: "externalContactNo",
					title:"Contact #",
					_numKey: true,
					openOnClick: true,
					default: true,
					sortable:true
				},
				{
					field: "externalContactName",
					title:"Contact Name",
					openOnClick: true,
					default: true,
					sortable:true
				},
				{
					field: "email",
					default: true,
					datatype:"email",
					fn_hrefLink: (type,value)=> {return util.fn_hrefLink(type, value);},
					sortable:true
				},
				{
					field: "phoneNo",
					default: true,
					datatype:"tel",
					fn_hrefLink: (type,value)=> {return util.fn_hrefLink(type, value);},
					valFmtFn: val => {return val?val.replace(/(\d{3})(\d{3})(\d{4})/,'$1.$2.$3'):null;},
					sortable:true
				},	
				{
					field: "role",
					title: "Title/Role",
					default:true,
					sortable:true
				},
				{
					field: "accountNo",
					title: "Account # (Primary)",
					linkFn: (col, row, vc) => {
						return {path: fn_hrefVwRec('acct', row['accountNo'])};
					},
					sortable:true
				},
				{
					field: "accountName",
					title: "Account Name (Primary)",
					default: true,
					linkFn: (col, row, vc) => {
						return {path: fn_hrefVwRec('acct', row['accountNo'])};
					},
					sortable:true,
					reportWidth:500
				},
				{field: "address",sortable:true,reportWidth:500},
				{field: "inactive",sortable:true},
				{field: "createdById", _refId: "teamMemberId",sortable:true},
				{field: "createdUTC",sortable:true},
				{field: "updatedById", _refId: "teamMemberId",sortable:true},
				{field: "updatedUTC",sortable:true},
				{field:"teamMemberNames",
				title: "Contact Owners",
				sortable:false
				},
				{field:"officePhoneNo",
				title:"Office#",
				datatype:"tel",
				sortable:true,
				fn_hrefLink: (type,value)=> {return util.fn_hrefLink(type, value);},
				valFmtFn: val => {return val?val.replace(/(\d{3})(\d{3})(\d{4})/,'$1.$2.$3'):null;}
				},
				{field:"mobilePhoneNo",
				title:"Mobile#",
				datatype:"tel",
				sortable:true,
				fn_hrefLink: (type,value)=> {return util.fn_hrefLink(type, value);},
				valFmtFn: val => {return val?val.replace(/(\d{3})(\d{3})(\d{4})/,'$1.$2.$3'):null;}
				},
				{field:"otherPhoneNo",
				title:"Other#",
				datatype:"tel",
				sortable:true,
				fn_hrefLink: (type,value)=> {return util.fn_hrefLink(type, value);},
				valFmtFn: val => {return val?val.replace(/(\d{3})(\d{3})(\d{4})/,'$1.$2.$3'):null;}
				},
				{field:"accounts",title:"Accounts"},
				{field:"lastContactDate",title: "Last Contact Date",datatype:"date",valFmtFn: val => {return util.fn_fmtDtm(val);}},
				{field:"notes", title:"Notes",htmlFn:val => {return val;}, 
				valFmtFn: val =>{return val?val.replaceAll('<p>','').replaceAll('</p>',''):null;},
				datatype:'multi-line',
				reportWidth:500
				},
			];
			var allColumns=[...columns, ...fn_addCustomFields()];
			return allColumns;
		}
	},
	methods: {
		m_tabClick(t){
			t.withArchived=false;
			t.filterBtns||[].filter(b=>b.osNm == 'Archived').forEach(x =>{ x.state = false;});
			this.d_tabCurr=t;
			window.localStorage.setItem(window.location.href+'-quickFilter',JSON.stringify(this.d_tabCurr.qryPrms));
				}		
	},
	watch: {
		d_tabCurr(nv, ov) {
			if (nv.ix == 1) this.$parent.d_cuFilter = true;
			else if (ov.ix == 1 || nv == 0) this.$parent.d_cuFilter = null;

			if (ov.ix >= 0) fn_setTabProps(nv, this);
			window.localStorage.setItem(window.location.href+'-quickFilter',JSON.stringify(nv.qryPrms));
		},
		'$parent.c_cutmKey'(nv, ov) {
			let ct = this.d_tabCurr;
			if (ct.ix == 0 && ov != -1) fn_setTabProps(ct, this);
		},
	}
};
function fn_getTabs(vc) {
	let tbInfoHelper = (who) => `Contacts on which ${who} a Contact Owner`;
	let tabs = [
		{
			ix: 0,
			lbl: 'All',
			tblIdKey: '',
			fn_qryPrms: () => {
				let tmf = vc.$parent.d_tmFilter;
				return {
					ix:0,
					teamMemberId: tmf ? tmf.teamMemberId : null,
					withArchived:vc.d_withArchived,
				};
			},
			fn_tbInfo: () => !vc.$parent.d_tmFilter ? null : tbInfoHelper('the selected Team Member is'),
		},
		{
			ix: 1,
			lbl: 'My Contacts',
			tblIdKey: '-currentUser',
			fn_qryPrms: () => {
				return {
					ix:1,
					teamMemberId:vc.d_teamMemberId,
					currentUser: true,
					withArchived:vc.d_withArchived,
				};
			},
			fn_tbInfo: () => tbInfoHelper('you are'),
		},
		{
		ix: 2,
		lbl: 'By Last Contact Date',
		tblIdKey: '-lastContactDate',
		filterBtns: fn_lastContactDateFilters(),
		fn_fbTitle: (fb) => `${fb.date ?
								`Filter Contacts Last Contacted ${(fb.lastContactAfter ? 'in over' : 'in')} "${fb.date}"`
								: "Filter contacts never contacted"
								}`,
		fn_qryPrms: (tab) => {
			let fb = tab.filterBtns.filter(x => x.state)[0] || {};
			let tmId = vc.c_tmIdFilter;
			let cu = null;
			if (!tmId) cu = vc.c_cuFilter;
			return {
				ix:2,
				lastContactDateFilter:true,
				startDate: fb.startDate,
				endDate: fb.endDate,
				teamMemberId: tmId,
				currentUser: cu,
				withArchived:vc.d_withArchived,
			};
		},
		fn_tbInfo: () => null,
        fn_fbClick: (fb) => {
				vc.d_tabCurr.filterBtns.forEach(x => x.state = x.id == fb.id ? true : false);
				fn_setTabProps(vc.d_tabs[2], vc);
				window.localStorage.setItem(window.location.href+'-quickFilter',JSON.stringify(vc.d_tabCurr.qryPrms));
				fn_saveFilters(vc);
				},
		skipLoad:false
		}
	];
	
	tabs.forEach(x => {
		fn_setFilters(x);
		fn_setTabProps(x, vc);
	});
	

	return tabs;
}

function fn_note(vc) {
	let tmfLbl = vc.$parent.c_tmFilterLbl;
	let note = tmfLbl || 'Contacts';
	return (tmfLbl ? '' : 'All ') + note;
}

function fn_setTabProps(tab, vc) {
	tab.qryPrms = tab.fn_qryPrms(tab);
	tab.tbNote = fn_note(vc);
}
function fn_addCustomFields(){
	var customFields=refData.customFields.filter(c=>(c.context=='extr'));
	var customColumns=[];
	var customColumn;
	customFields.forEach(cf=>{
				customColumn={
						field: cf.name,
						title: cf.label,
						sortable:false,
						visible:true,
						datatype:cf.type,
						__dbvw: true,
						valFmtFn: cf.type=='money'?val => val?'$'+Number(val).toLocaleString():null:null,
						fn_hrefLink: ['email','tel','url'].includes(cf.type)?(type,value)=> 
						{if(type=='url'&&!value.includes('http')) value='http://'+value;
						return util.fn_hrefLink(type, value);}:null,
						fn_hrefAppLink: ['oppr','proj','acct','extr','cmpt','team'].includes(cf.type)?(type,value)=> {return util.fn_hrefVwRec(type, value);}:null,
						multiSelect:cf.multiSelect,
						listOfValues:cf.listOfValues,
						customField:true,
						};			
	if(customColumn.multiSelect) customColumn.valFmtFn=(val)=>{return val instanceof Array?val.join():null;};			
	customColumns.push(customColumn);

		});
	return customColumns;
}
//Last Contact Date Filter Helpers
function fn_lastContactDateFilters() {

	let subtractDays = (num) => {
		let dt = new Date();
		dt.setDate(dt.getDate() - num);
		return util.fn_isoDtStr(dt);
	};

	return [
	{
			id: 1,
			startDate:null,
			endDate: null,
			label: "Never contacted",
			state: true
		},
		{
			id: 2,
			startDate: subtractDays(90),
			endDate: subtractDays(120),
			label: "No contact over 90 days",
			state: false,
			
		},
		{
			id: 3,
			startDate: subtractDays(60),
			endDate: subtractDays(90),
			label: "No contact over 60 days",
			state: false
		},
		{
			id: 4,
			startDate: subtractDays(30),
			endDate: subtractDays(60),
			label: "No contact over 30 days",
			state: false
		},
			
	];
}
function fn_setFilters(tab) {
	let uonf = userSettings.userOptions.extrNavFilters || {};
	uonf = uonf[tab.ix] || [];

	if (tab.ix == 2 && uonf.length) {
		tab.filterBtns.forEach(fb => fb.state = false);
	}
	uonf.forEach(x => {
		let fb = tab.filterBtns.filter(fb => (fb.id) == x)[0];
		if (fb) fb.state = true;
	});
}
function fn_saveFilters(vc) {
	let val = {};
	vc.d_tabs.forEach(t => {
	if(t.ix == 2) val[t.ix] = t.filterBtns.filter(x => x.state).map(x => x.id);
	});
	
	util.fn_saveUserOpts('extrNavFilters', null, val);
}

</script>

<style scoped lang="less">
.btn-active{color:white;
			background-color:orange;    //#28a745;
			}
</style>